import React from 'react'
import { type RPPDomain } from 'utils/core/RPPCore.types'
import { NavItem } from 'legacy/components/Nav/nav.types'
import { roleManagementRouter } from 'domains/role-management/routing/roleManagementRouter'
import { type DomainMessages } from 'domains/role-management/utils/domain/intl'
import { routes } from 'domains/role-management/routing/routes'
import EN_US from 'domains/role-management/translations/en-US'
import { type DomainAccessControlConfig } from 'domains/role-management/utils/domain/accessControl'
import { RoleManagementAccessControl } from 'domains/role-management/access-control/roleManagementAccess.configuration'
import { NewBadge } from 'gin-and-tonic/common/badges/NewBadge'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'role-management',
  routes,
  translations: { EN_US },
  routers: {
    scoped: [roleManagementRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.Admin,
      subNavItems: [
        {
          type: 'item',
          labelId: 'roleManagementDomain.title',
          route: 'role-management-roles-list',
          position: 2,
          accessControl: RoleManagementAccessControl,
          navBadge: <NewBadge />,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
